import {ofType, combineEpics} from 'redux-observable';
import {map, mergeMap} from 'rxjs/operators';

import demoService from '../api/demo/demoService';
import {valid} from '../api';
import {
  RDX_DEMO_DATA_FETCH,
  getDemoDataDone,
  RDX_DEMO_DATA_FETCH_ERR,
  RDX_DEMO_DATA_SAVE,
  saveDemoDataDone,
  RDX_DEMO_DATA_SAVE_ERR,
} from '../redux/demoAction';
import {
  buildGetDemoRequest,
  convertGetDemoResponse,
  buildSaveDemoRequest,
} from '../convertor/demoConvertor';

const demoFetchDataEpic = (action$) =>
  action$.pipe(
    ofType(RDX_DEMO_DATA_FETCH),
    mergeMap((action) =>
      demoService.getDemoData(buildGetDemoRequest(action)).pipe(
        map((wResponse) => {
          if (valid(wResponse)) {
            // normal response, go normal flow
            const data = convertGetDemoResponse(wResponse);
            return getDemoDataDone(data);
          } else {
            // error response , go error flow
            return {type: RDX_DEMO_DATA_FETCH_ERR};
          }
        }),
      ),
    ),
  );

const demoSaveDataEpic = (action$) =>
  action$.pipe(
    ofType(RDX_DEMO_DATA_SAVE),
    mergeMap((action) =>
      demoService.saveDemoData(buildSaveDemoRequest(action.data)).pipe(
        map((wResponse) => {
          if (valid(wResponse)) {
            console.log('demoSaveDataEpic.RDX_DEMO_DATA_SAVE');
            // normal response, go normal flow
            return saveDemoDataDone();
          } else {
            // error response , go error flow
            return {type: RDX_DEMO_DATA_SAVE_ERR};
          }
        }),
      ),
    ),
  );

const demoEpic = combineEpics(demoFetchDataEpic, demoSaveDataEpic);

export default demoEpic;
